<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      weAppId: 'wxac43fa84faa1b7fd',
      weAppEnv: 'release' // release;trial;develop
    }
  },
  created() {
    const channel = ['development', 'test'].includes(process.env.VUE_APP_TITLE)
      ? 'scene=channel=UK171535'
      : 'scene=channel=UK743673'
    // 判断是否是百度渠道
    const res = this.parseUrlSearch()
    if (Object.keys(res).includes('bd_vid')) {
      //标记百度渠道：scene=channel%3DUK743673
      const query = channel + '&bd_vid=' + res['bd_vid'] + '&host=' + window.location.origin
      window.location.href = this.generateWeAppScheme(query) // 唤起小程序
    }
  },
  methods: {
    // 生成小程序scheme
    generateWeAppScheme(query) {
      const encodeQuery = encodeURIComponent(query)
      return `weixin://dl/business/?appid=${this.weAppId}&path=pages/index/index&query=${encodeQuery}&env_version=${this.weAppEnv}`
    },
    parseUrlSearch() {
      //解析url参数，转成对象
      let search = window.location.search
      let obj = {}
      if (search) {
        search = search.slice(1)
        let arr = search.split('&')
        arr.forEach((item) => {
          let arr2 = item.split('=')
          obj[arr2[0]] = arr2[1]
        })
      }
      return obj
    }
  }
}
</script>

<style lang="less">
@import url('@/style/main.css');
#app {
  font-family: Avenir, Helvetica, Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
